module.exports = __webpack_public_path__ + "c53b0d23cf49e8bfe2f15a02b44c7a7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/head/goldencity.jpg
// module id = 898
// module chunks = 0